import { DrugSku } from 'features/questionnaire/api/questionnaireApi';
import { TreatmentRecommendation } from 'features/questionnaire/domain/edRecommendation';

export type EdFlowState = {
  sessionId: string;
  questionnaireId: string;
  recommendation: TreatmentRecommendation | null;
  strengthMg?: number;
  monthlyQuantity?: number;
  selectedSku?: DrugSku;
};

const STORAGE_KEY = 'talo.ed.flow';

const isStorageAvailable = () => typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';

export const readEdFlowState = (): EdFlowState | null => {
  if (!isStorageAvailable()) return null;
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<EdFlowState>;
    if (!parsed.sessionId || !parsed.questionnaireId) return null;
    return parsed as EdFlowState;
  } catch (error) {
    console.warn('Failed to read ED flow state from storage', error);
    return null;
  }
};

export const writeEdFlowState = (state: EdFlowState): void => {
  if (!isStorageAvailable()) return;
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
};

export const mergeEdFlowState = (partial: Partial<EdFlowState>): void => {
  if (!isStorageAvailable()) return;
  const current = readEdFlowState();
  const next = { ...current, ...partial } as EdFlowState;
  if (!next.sessionId || !next.questionnaireId) return;
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
};

export const clearEdFlowState = (): void => {
  if (!isStorageAvailable()) return;
  window.sessionStorage.removeItem(STORAGE_KEY);
};
